import { useContext, useState } from "react";
import { Container, Table } from "react-bootstrap";
import Navigation from "../Components/Navbar";
import { Link, useLocation } from "react-router-dom";
import { UserContext } from "../context/UserContext";
import Spinner from "../Components/Spinner";
import api from "../Components/Api/Api";
const Printer = () => {
    const {user} = useContext(UserContext) 
    const location = useLocation();   
    const [numorc, setNumorc] = useState('')
    const [page, setPage] = useState(0)
    const [perpage, setPerpage] = useState(10)
    const [dtini, setDtini] = useState('')
    const [dtfim, setDtfim] = useState('')  
    const [ShowLoading, setShowLoading] = useState(false)  
    const [orcamentos, setOrcamentos] = useState([])     
    const getnumorc = (el: any) => {
        setNumorc(el.target.value)
        //console.log(el.target.value)
    };
    const credentials = btoa(`${user.userRest}:${user.passRest}`); 
    const headers = {
        'Content-Type': 'application/json;charset=UTF-8',
        "Access-Control-Allow-Origin": "*",
        "User-Agente": "PneusBrasil",
        "Accept": "*/*",
        'Authorization': `Basic ${credentials}`,
      }     
    function getentradas () {
        setTimeout(() => {
          // const headers = {
          //   'Content-Type': 'application/json;charset=UTF-8',
          //   "Access-Control-Allow-Origin": "*",
          //   "User-Agente": "PneusBrasil",
          //   "Accept": "*/*",
          //   // 'Authorization': "Basic YWRtaW46QE5lbHNvbjEx",
          // }       
        setShowLoading(true)
        api.get('ConsultaOrcamento?filial='+user.filial+'&consulta='+numorc,{headers})
        .then(response => {
              if (response.data.Orcamento.length > 0 ){  
                  setOrcamentos(response.data.Orcamento)
                  setShowLoading(false)  
                  setNumorc('')
                  //setInfoveuculo('Placa: ' + placa + ' Modelo: ' + response.data.Dadosveiculo[0]['modelo'] + ' Cor: ' + response.data.Dadosveiculo[0]['cor'])                     
              }else{
                  //setInfoveuculo('Placa não cadastrada!')
                  setShowLoading(false)
                  setNumorc('')
              }                                   
        });
      }, 10 );        
      };    
    return (
        <>
        <Navigation />
        <Container>
            <div className='mt-4'>
            <label className='me-1' htmlFor="Orçamento nº">Orçamento nº:</label>
            <input type='text' className='ms-2 sm-blok' onChange={(e) => getnumorc(e)} required></input>
            <button className='ms-md-2 btn btn-success sm-blok' onClick={getentradas}>Buscar</button>
            </div> 
            <div className='mt-2'>    
          <Table striped bordered hover variant="light" responsive className="tabela">
            <thead>
                <tr className='col-title'>
                <th>Id</th>
                <th>Orçamento</th>
                <th>Dt Emissao</th>
                <th>Cliente</th>
                <th>Loja</th>
                <th>Nome</th>
                <th>Placa</th>
                <th>Imprimir</th>                 
                </tr>
            </thead> 
            <tbody> 
            {orcamentos.map((list: any) => (           
              <tr key={list.id}>
                <td>{list.id}</td>
                <td>{list.Num}</td>
                <td>{list.dtemissao}</td>
                <td>{list.cliente}</td>
                <td>{list.loja}</td>
                <td>{list.nomecliente}</td>
                <td>{list.placa}</td>                   
                <td><Link to='/Orcamento' state={list.Num}>Imprimir</Link></td>
              </tr>
            ))}                         
            </tbody>
          </Table>                      
        </div>            

            <div className="mt-4">     
            <button className='btn btn-outline-secondary sm-blok'><Link to='/Entrada'> Voltar</Link></button>
            {/* {numorc !== '' ? 
            (<button className='ms-5 btn btn-outline-success sm-blok'><Link to='/Orcamento' state={numorc}> Imprimir</Link></button>) :
            ('')  }   */}
            </div>          
        </Container> 
        <Spinner isLoading={ShowLoading} />       
        </>
    )
}

export default Printer;